<template>
  <div class="language-selector">
    <select 
      v-model="selectedLanguage" 
      @change="changeLanguage"
      class="language-select"
    >
      <option value="zh">中文</option>
      <option value="en">English</option>
      <option value="fr">Français</option>
      <option value="de">Deutsch</option>
      <option value="nl">Nederlands</option>
      <option value="es">Español</option>
    </select>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { setLocale } from '../i18n'

const { locale } = useI18n()
const selectedLanguage = ref(locale.value)

// 监听 locale 的变化，保持同步
watch(locale, (newLocale) => {
  selectedLanguage.value = newLocale
})

const changeLanguage = () => {
  setLocale(selectedLanguage.value)
}

onMounted(() => {
  // 获取系统语言
  const userLanguage = navigator.language.toLowerCase()
  const systemLanguage = (() => {
    if (userLanguage.startsWith('zh')) return 'zh'
    if (userLanguage.startsWith('fr')) return 'fr'
    if (userLanguage.startsWith('de')) return 'de'
    if (userLanguage.startsWith('nl')) return 'nl'
    if (userLanguage.startsWith('es')) return 'es'
    return 'en'
  })()
  
  // 如果没有保存的语言设置，使用系统语言
  const savedLanguage = localStorage.getItem('language')
  if (!savedLanguage) {
    setLocale(systemLanguage)
  } else {
    selectedLanguage.value = savedLanguage
    // 确保 i18n 和 localStorage 中的语言保持一致
    if (locale.value !== savedLanguage) {
      setLocale(savedLanguage)
    }
  }
})
</script>

<style scoped>
.language-selector {
  display: inline-block;
  position: relative;
}

.language-select {
  appearance: none;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: var(--radius);
  color: white;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem 2rem 0.5rem 1rem;
  width: auto;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 1em;
}

.language-select:hover {
  border-color: rgba(255, 255, 255, 0.5);
}

.language-select:focus {
  outline: none;
  border-color: white;
}

.language-select option {
  background-color: var(--bg-color);
  color: var(--text-color);
}

@media (max-width: 480px) {
  .language-select {
    font-size: 0.9rem;
    padding: 0.4rem 1.8rem 0.4rem 0.8rem;
  }
}
</style> 